import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, TargetIcon, BarChartIcon, LightbulbIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid1Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2044">
      <SEO data-id="element-2045" />
      <Header data-id="element-2046" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2047">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2048">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2049">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2050" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2051">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2052">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2053">
                <img src="https://cdn.magicpatterns.com/uploads/3gNHu8EmmCiAuc7tUYPC6J/Mogelijk_voor_website_(1).jpg" alt="Rocco" className="w-full h-full object-cover" data-id="element-2054" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2055">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2056">
                Naam 1
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2057">
                Oprichter & Strateeg
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2058">
                <p className="mb-4" data-id="element-2059">
                  Als oprichter van Noord Digital en bedenker van de CorePrint
                  methode, ben ik dagelijks bezig met het vertalen van complexe
                  bedrijfsdoelstellingen naar meetbare online strategieën. Mijn
                  passie ligt op het snijvlak van data, psychologie en
                  technologie.
                </p>
                <p className="mb-4" data-id="element-2060">
                  Voordat ik Noord Digital startte, zag ik te vaak dat bedrijven
                  investeerden in marketing zonder duidelijk plan of meetbaar
                  resultaat. Dat moest anders. Met CorePrint hebben we een
                  fundament gebouwd dat groei voorspelbaar maakt.
                </p>
                <p data-id="element-2061">
                  In mijn werk focus ik me op de grote lijnen: waar liggen de
                  kansen in de markt, hoe positioneren we onze klanten het
                  sterkst, en welke kanalen leveren de hoogste ROI op. Ik geloof
                  heilig dat elke beslissing onderbouwd moet worden met data,
                  niet met onderbuikgevoel.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2062">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2063">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2064">
                  <LightbulbIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2065" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2066">Strategy</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2067">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2068" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2069">CorePrint</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2070">
                  <BarChartIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2071" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2072">Data-analyse</h3>
                </div>
              </div>

              <button onClick={() => navigate('/')} className="bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2073">
                Neem contact op met Rocco
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2074" />
    </div>;
};